import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect, useSelector } from 'react-redux'
import { Navigate, Outlet, useLocation, useParams, useSearchParams } from 'react-router-dom'
import links from '../app/links'
import { getIo, useAuthSocketIo } from '../io'
import DataUpdateService from '../components/DataUpdateService'
import DataMigrationService from '../components/DataMigrationService'
import { selectViewerId } from '../../common/app/reducer'
import { Link } from '../components'

const AuthorizedPage = ({}) => {
  const viewerId = useSelector(selectViewerId)
  const storageLoaded = useSelector(state => state.app.storageLoaded)

  const location = useLocation()

  // Wait for persisted auth state to rehydrate from localStorage before deciding
  // the user is unauthenticated. On a refresh the viewer arrives asynchronously
  // (APP_STORAGE_LOAD); redirecting to /auth before that and bouncing back once it
  // lands remounts this whole subtree, double-firing its mount-time data fetches
  // (e.g. /api/v1/orders).
  if (!storageLoaded) return null

  if (!viewerId) {
    const state = window.location.hash !== '#logout' ? { from: location } : null
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to={Link.AUTH} state={state} replace />
  }

  return <AuthorizedContent />
}

const AuthorizedContent = () => {
  useAuthSocketIo()
  return (
    <>
      <DataUpdateService />
      <DataMigrationService />
      <Outlet />
    </>
  )
}

export default AuthorizedPage
